import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const steps = [
  ["Tell us who it’s for", "Choose the person and the occasion."],
  ["Share your memories", "Add photos, stories, messages and the details that matter."],
  ["Shape your story", "Pick the tone, style and chapters, then review your answers."],
  ["Bring it to life", "Order your book. Your draft is written next, ready to read and edit online."],
];
export const HowItWorks = () => <section id="how" className="how-section" aria-labelledby="how-title" data-testid="how-it-works">
  <div className="brand-container">
    <div className="how-head">
      <p className="eyebrow">How it works</p>
      <h2 id="how-title" className="display-l">Four steps to <em>their book.</em></h2>
    </div>
    <ol className="how-steps">{steps.map(([title, body], i) => <li key={title} data-testid={`how-step-${i + 1}`}>
      <span className="how-num">{String(i + 1).padStart(2, "0")}</span>
      <h3 className="display-m">{title}</h3>
      <p>{body}</p>
    </li>)}</ol>
    <div className="how-cta">
      <Link to="/create/new" className="btn-primary" data-testid="how-create-cta">Create Your Keepsake <ArrowRight size={16}/></Link>
      <p>No account needed. Your answers save as you go.</p>
    </div>
  </div>
</section>;
